export default {
  DELETED_ARCHIVED: 6,
  SIGNED_BY_THE_PARTIES_VALID: 5,
  SENT: 4,
  SIGNED_BY_THE_SENDER: 3,
  AGREEMENT: 2,
  CREATE: 1,
};
